import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/browser';
import { HttpClient } from '@wix/http-client';
import { createBrowserHistory, createMemoryHistory } from 'history';
import rootReducerCreator from './components/rootReducer';
import { create } from '@wix/fedops-logger';
import setupBiLogger from './setupBiLogger';
import {
  withBIFactory,
  services as createServices,
  ARENA_DSN,
  reduxMiddleware as sentryReduxMiddleware,
  commonConfig,
} from '@wix/experts-common';
import isServer from './utils/isServer';
import { getQueryParamValueFromUrl } from './utils/queryParamsTransformer';
import { baseURL } from './fromWindow';

const fedopsLogger = create('experts-arena');
const biLogger = setupBiLogger();
const withBI = withBIFactory(biLogger, Sentry);
const guid = !isServer ? window.__USER_GUID__ : undefined;
Sentry.init({ dsn: ARENA_DSN, ...commonConfig('experts-arena') });
Sentry.configureScope(scope => scope.setUser({ id: guid }));

const services = createServices();

export default options => {
  const {
    url = '/',
    state = {},
    isTest = false,
    isInternal = false,
    isMobile = false,
    httpClient = new HttpClient({ baseURL }),
  } = options;

  // Create a history depending on the environment
  const history =
    isServer || isTest
      ? createMemoryHistory({
          initialEntries: [url],
        })
      : createBrowserHistory({ basename: window.__BASEURL__ });

  const composeEnhancers = !isServer
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

  // Do we have preloaded state available? Great, save it.
  const initialState = !isServer ? window.__PRELOADED_STATE__ : state;

  // Delete it once we have it stored in a variable
  if (!(isServer || isTest)) {
    delete window.__PRELOADED_STATE__;
  }

  const isInModal = getQueryParamValueFromUrl(url, 'inModal') === 'true';

  services.clear();

  // const initialState = isTest ? state : { experiments: JSON.parse(window.__EXPERIMENTS__) }
  services({
    withBI,
    fedopsLogger,
    isInternal,
    isMobile,
    isInModal,
    httpClient,
  });
  // Create the store
  const store = createStore(
    rootReducerCreator(history),
    initialState,
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history),
        thunk.withExtraArgument(services()),
        sentryReduxMiddleware(Sentry),
      ),
    ),
  );

  return {
    store,
    history,
    services,
  };
};
